module.exports = __webpack_public_path__ + "media/images/shared/delivery/rc-8d6ae4e0a62efed88c66dc0cad85c288.jpg";